import FilterInTable from "../../../../Manage/FilterInTable"
import SellerActionDropdown from "../../../../../components/common/SellerCommonComponents/SellerActionDropdown/SellerActionDropdown"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const All = () => {

  const data = [
    { promotionPeriod: '29 July -10 August', deliveryRegions: 'Lahore, Faisalabad', applicability: 'Specific Products', minOrderValue: 50, status: "Active" },
    { promotionPeriod: '29 July -10 August', deliveryRegions: 'Lahore, Faisalabad', applicability: 'Specific Products', minOrderValue: 50, status: "Active" },
    { promotionPeriod: '29 July -10 August', deliveryRegions: 'Lahore, Faisalabad', applicability: 'Specific Products', minOrderValue: 50, status: "Active" },
  ]

  const columns = [
    { name: 'Promotion Period', selector: row => row.promotionPeriod, wrap: true },
    { name: 'Delivery Regions', selector: row => row.deliveryRegions, wrap: true },
    { name: 'Applicability', selector: row => row.applicability, wrap: true },
    { name: 'Minimum Order Value', cell: row => <span>${row.minOrderValue}</span>, wrap: true },
    { name: 'Status', selector: row => row.status, wrap: true },
    { name: "Action", cell: () => <SellerActionDropdown /> }
  ]

  return (
    <div className="bg-white p-3">

      <div className="mb-3">
        <FilterInTable componentName="Free Delivery" />
      </div>

      <DatatableComponent columns={columns} data={data} type='gray' />


    </div>
  )
}

export default All